import { createRouter, createWebHistory } from "vue-router";
import "nprogress/nprogress.css";
import "@/app/layouts/types";

import modules from "@/app/router/modules";
import { authGuard, setRouterForGuards } from "@/app/router/utils/guards";
import { progress } from "@/shared/lib/browser/progress";

const router = createRouter({
  history: createWebHistory(),
  routes: modules,
});

setRouterForGuards(router);

router.beforeEach(async (to, from) => {
  progress.start();

  const title = (to.meta as { title?: string }).title;
  document.title = title ? `Prism | ${title}` : "Prism";

  return authGuard(to, from);
});

router.afterEach(() => {
  progress.done();
});

router.onError(() => {
  progress.done();
});

export default router;
